import { render, staticRenderFns } from "./UsersVue.vue?vue&type=template&id=45364eb0&scoped=true&"
import script from "./UsersVue.vue?vue&type=script&lang=js&"
export * from "./UsersVue.vue?vue&type=script&lang=js&"
import style0 from "./UsersVue.vue?vue&type=style&index=0&id=45364eb0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45364eb0",
  null
  
)

export default component.exports